import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import './styles/tables.css';
import App from './App';
import { UserProvider } from './context/UserContext';
import { I18nProvider } from './i18n/I18nContext';

import '@fullcalendar/daygrid';        // CSS automatically included
import '@fullcalendar/timegrid';
import '@fullcalendar/resource-timeline';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <I18nProvider>
      <UserProvider>
        <App />
      </UserProvider>
    </I18nProvider>
  </React.StrictMode>
);